import React, { act, useEffect, useState } from "react";
import ChallanGeneratedGraph from "../Common/ChallanGeneratedGraph";
import "../style.css";
import ChallaRequestReceived from "../Common/ChallanRequestReceived";
import DutyReports from "../Common/DutyReports";
import TodaysFuelStatusGraph from "./TodaysFuelStatusGraph";
import FuelConsumptionCentral from "./FuelConsumptionCentral";
import VehicleStatusGraph from "./VehicleStatusGraph";
import VehicleStatusList from "./VehicleStatusList";
import OBTSCollection from "./OBTSCollection";
import GoodsRequested from "../Common/GoodsRequested";
import CentralDashboardService from "../../services/centraldashboard.service";
import InvoiceGeneratedGraph from "../Common/InvoiceGeneratedGraph";
import TollCollection from "../Common/TollCollection";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import MapReport from "./MapReport";
import KmAndFuelReport from "./KmAndFuelReport";

function CentralDashboard() {
  const currentDate = new Date();
  const [activeYearly, setActiveYearly] = useState(0);
  const [loading, setLoding] = useState(false);
  const [revenuCollected, setRevenuCollected] = useState({
    totalRevenue: "",
    obtsCollection: "",
    goodsCollection: "",
    tollCollectionCounter: "",
    tollCollectionOnline: "",
    totalTollCollection: "",
  });
  const [showCalendar, setShowCalendar] = useState(false);
  const [formdate, setFormdate] = useState(
    moment(new Date(currentDate)).format("YYYY-MM-DD"),
  );
  const [details, setDetails] = useState({
    fromDate: moment(new Date(currentDate)).format("YYYY-MM-DD"),
    formatedFromDate: moment(new Date(currentDate)).format("DD-MM-YY"),
  });
  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };

  useEffect(() => {
    fetchRevenueCollection();
  }, [activeYearly, details.fromDate]);

  const fetchRevenueCollection = () => {
    if (activeYearly === 0) {
      const payload = details.fromDate;

      setLoding(true);
      CentralDashboardService.getDaywiseRevenue(payload)
        .then((resp) => {
          // console.log(resp.data);
          const response = resp.data[0];
          const formatter = new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 2,
          });

          setLoding(false);

          // console.log(resp.data);
          setRevenuCollected({
            totalRevenue: formatter.format(response.totalRevenue),
            obtsCollection: formatter.format(response.obtsCollection),
            goodsCollection: formatter.format(response.goodsCollection),
            tollCollectionCounter: formatter.format(
              response.tollCollectionCounter,
            ),
            tollCollectionOnline: formatter.format(
              response.tollCollectionOnline,
            ),
            totalTollCollection: formatter.format(
              parseFloat(response.tollCollectionCounter) +
                parseFloat(response.tollCollectionOnline),
            ),
          });
        })
        .catch((e) => console.log(e));
    } else {
      const payload = activeYearly.toString();

      setLoding(true);
      CentralDashboardService.newRevenueGenerate(payload)
        .then((resp) => {
          // console.log(resp.data);
          const response = resp.data[0];
          const formatter = new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 2,
          });

          setLoding(false);

          // console.log(resp.data);
          setRevenuCollected({
            totalRevenue: formatter.format(response.totalRevenue),
            obtsCollection: formatter.format(response.obtsCollection),
            goodsCollection: formatter.format(response.goodsCollection),
            tollCollectionCounter: formatter.format(
              response.tollCollectionCounter,
            ),
            tollCollectionOnline: formatter.format(
              response.tollCollectionOnline,
            ),
            totalTollCollection: formatter.format(
              parseFloat(response.tollCollectionCounter) +
                parseFloat(response.tollCollectionOnline),
            ),
          });
        })
        .catch((e) => console.log(e));
    }
  };

  const handleChange = (newValue) => {
    setActiveYearly(0);
    setFormdate(newValue);

    setDetails({
      ...details,
      fromDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedFromDate: moment(new Date(newValue)).format("DD-MM-YY"),
    });

    setShowCalendar(false);
  };

  return (
    <>
      <div className="row m-0">
        <div className="col col-12 col-md-12 col-lg-12">
          <div className="graph-outline graph-outline2 mb-3">
            <div
              className="graph-header"
              style={{ justifyContent: "space-between" }}
            >
              <div className="graph-heading-main">
                <span>Revenue Generated</span>
                <span>
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 60 60"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1886_1435)">
                      <path
                        d="M52.75 39.625C52.0825 39.0202 51.2823 38.5807 50.4138 38.3418C49.5453 38.103 48.6329 38.0716 47.75 38.25L35.375 40.375C35.3595 38.8228 34.7304 37.3398 33.625 36.25L24.75 27.5H6.25C5.58696 27.5 4.95107 27.7634 4.48223 28.2322C4.01339 28.7011 3.75 29.337 3.75 30C3.75 30.663 4.01339 31.2989 4.48223 31.7678C4.95107 32.2366 5.58696 32.5 6.25 32.5H22.75L30.125 39.875C30.3008 40.0607 30.3988 40.3068 30.3988 40.5625C30.3988 40.8183 30.3008 41.0643 30.125 41.25C29.9187 41.4345 29.6517 41.5365 29.375 41.5365C29.0983 41.5365 28.8313 41.4345 28.625 41.25L24.25 36.875C23.7687 36.4445 23.1457 36.2066 22.5 36.2066C21.8543 36.2066 21.2313 36.4445 20.75 36.875C20.2839 37.3633 20.0238 38.0124 20.0238 38.6875C20.0238 39.3626 20.2839 40.0117 20.75 40.5L25.125 44.75C25.6703 45.3245 26.3307 45.7773 27.0631 46.0789C27.7955 46.3805 28.5833 46.524 29.375 46.5C30.1403 46.4966 30.9 46.37 31.625 46.125L48.625 43.125C48.7999 43.0932 48.9795 43.099 49.152 43.1421C49.3244 43.1852 49.4857 43.2646 49.625 43.375C49.8502 43.6127 49.9832 43.923 50 44.25C50.0059 44.5424 49.9091 44.8277 49.7263 45.0561C49.5436 45.2845 49.2866 45.4416 49 45.5L25.75 49.75L12.125 38.625H6.25C5.58696 38.625 4.95107 38.8884 4.48223 39.3572C4.01339 39.8261 3.75 40.462 3.75 41.125C3.75 41.788 4.01339 42.4239 4.48223 42.8928C4.95107 43.3616 5.58696 43.625 6.25 43.625H10.375L24.25 55L49.875 50.375C51.3207 50.1359 52.6327 49.3864 53.573 48.2626C54.5134 47.1388 55.0196 45.7152 55 44.25C55.0097 43.3573 54.8115 42.4747 54.4209 41.6719C54.0304 40.8691 53.4583 40.1683 52.75 39.625Z"
                        fill="#24A36C"
                      />
                      <path
                        d="M42.8754 25.125C41.0349 25.1613 39.2338 24.5902 37.7504 23.5C37.4727 23.3153 37.1608 23.1881 36.8331 23.1258C36.5054 23.0635 36.1685 23.0674 35.8424 23.1373C35.5162 23.2072 35.2073 23.3416 34.9339 23.5327C34.6605 23.7238 34.4281 23.9677 34.2504 24.25C34.0533 24.4844 33.9062 24.7567 33.818 25.05C33.7298 25.3433 33.7024 25.6515 33.7375 25.9558C33.7726 26.2601 33.8695 26.554 34.0221 26.8195C34.1748 27.085 34.3801 27.3166 34.6254 27.5C36.2339 28.6288 38.0675 29.3964 40.0004 29.75V32.5C40.0004 33.163 40.2638 33.7989 40.7327 34.2678C41.2015 34.7366 41.8374 35 42.5004 35C43.1635 35 43.7994 34.7366 44.2682 34.2678C44.737 33.7989 45.0004 33.163 45.0004 32.5V29.75C46.3717 29.5478 47.6652 28.9872 48.7504 28.125C49.534 27.5498 50.1694 26.7963 50.6041 25.9268C51.0388 25.0574 51.2604 24.097 51.2504 23.125C51.2504 18.5 47.0004 17 43.3754 16.25C39.7504 15.5 39.0004 14.625 39.0004 14C39.0004 13.375 39.2504 13.25 39.6254 12.875C40.3151 12.5043 41.0937 12.3312 41.8754 12.375C43.3279 12.3624 44.7555 12.7518 46.0004 13.5C46.2535 13.7065 46.5485 13.8554 46.8649 13.9365C47.1813 14.0175 47.5115 14.0286 47.8327 13.9692C48.1538 13.9097 48.4582 13.781 48.7246 13.5921C48.991 13.4031 49.2131 13.1584 49.3754 12.875C49.5897 12.6194 49.7477 12.3215 49.8392 12.0008C49.9307 11.68 49.9536 11.3436 49.9064 11.0134C49.8593 10.6832 49.7431 10.3667 49.5654 10.0844C49.3878 9.80211 49.1527 9.56039 48.8754 9.375C47.6868 8.64132 46.3732 8.13284 45.0004 7.875V5C45.0004 4.33696 44.737 3.70107 44.2682 3.23223C43.7994 2.76339 43.1635 2.5 42.5004 2.5C41.8374 2.5 41.2015 2.76339 40.7327 3.23223C40.2638 3.70107 40.0004 4.33696 40.0004 5V7.75C36.2504 8.375 33.7504 10.875 33.7504 14.25C33.7504 17.625 37.8754 20.375 41.8754 21.125C45.8754 21.875 46.0004 22.75 46.0004 23.375C46.0004 24 44.6254 25.125 42.8754 25.125Z"
                        fill="#24A36C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1886_1435">
                        <rect width="60" height="60" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </div>
              <div className="graph-yearly-filter">
                <div
                  style={{ display: "flex" }}
                  className={
                    activeYearly === 0
                      ? "date-range filter-box active"
                      : "filter-box"
                  }
                >
                  <div className="flex position-relative">
                    <span>
                      {details.formatedFromDate !== ""
                        ? details.formatedFromDate
                        : "From"}
                    </span>
                    <span>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={(e) => {
                          setShowCalendar(!showCalendar);
                        }}
                      >
                        <path
                          d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.83333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                          stroke="#6E6284"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    {showCalendar && (
                      <div
                        className="calendarModal position-absolute"
                        style={{
                          boxShadow: "0px 0px 3px 0px grey",
                        }}
                      >
                        <Calendar
                          onChange={handleChange}
                          value={formdate}
                          maxDate={currentDate}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className={
                    activeYearly === 1 ? "filter-box active" : "filter-box"
                  }
                  onClick={() => handleYearlyFilter(1)}
                >
                  Last 7 Days
                </div>
                <div
                  className={
                    activeYearly === 2 ? "filter-box active" : "filter-box"
                  }
                  onClick={() => handleYearlyFilter(2)}
                >
                  This Month
                </div>
                <div
                  className={
                    activeYearly === 3 ? "filter-box active" : "filter-box"
                  }
                  onClick={() => handleYearlyFilter(3)}
                >
                  This Year
                </div>
              </div>
            </div>
            {loading ? (
              <>
                <div
                  class="spinner-border "
                  style={{ color: "rgb(247, 177, 140)" }}
                  role="status"
                >
                  <span class="sr-only"></span>
                </div>
                <span>Data is Loading...</span>
              </>
            ) : (
              <>
                <div className="row m-0">
                  <div className="col col-12 col-md-6 col-lg-3 mb-3 mb-sm-3 mb-md-3 mb-lg-0">
                    <div className="stats-box">
                      <div className="left">
                        <span className="heading">Total Revenue</span>
                        <span className="amt">
                          ₹{revenuCollected.totalRevenue}
                        </span>
                      </div>
                      <div className="right" style={{ paddingTop: "10px" }}>
                        <span className="icon">
                          <svg
                            width="60"
                            height="60"
                            viewBox="0 0 60 60"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M50.6727 11.1274L53.2792 7.12301C54.2027 5.70633 54.2747 3.89812 53.4683 2.41219C52.6636 0.925313 51.1083 0 49.4181 0H14.5663C13.0074 0 11.5547 0.7875 10.7034 2.09355L6.72158 8.21027C5.79802 9.62695 5.72607 11.4352 6.53255 12.9211C7.13197 14.0291 8.14904 14.8256 9.32806 15.1596L6.72158 19.1639C5.79802 20.5806 5.72607 22.3888 6.53255 23.8747C7.08158 24.89 7.98169 25.6433 9.03462 26.0187C8.36865 26.8179 7.96716 27.8467 7.96716 28.969V34.4817C7.96716 35.6653 8.42255 36.803 9.23806 37.6597L29.1526 58.5697C30.022 59.4833 31.2281 59.9999 32.4899 59.9999H41.3085C43.8538 59.9999 45.9168 57.9369 45.9168 55.3916V53.2584C45.9168 52.075 45.4614 50.9373 44.646 50.0804L31.8797 36.6762C36.4195 34.5034 40.0215 30.8123 41.8667 26.2868H45.4345C46.9933 26.2868 48.4461 25.4993 49.2974 24.1932L53.2792 18.0765C54.2027 16.6598 54.2747 14.8516 53.4683 13.3657C52.8688 12.2578 51.8518 11.4613 50.6727 11.1274ZM38.0541 15.5619H49.4181L45.4345 21.6786H38.4159C37.2529 28.5578 30.9077 33.8734 23.1401 34.1811L41.3085 53.2586V55.3917H32.4899L12.5754 34.4818V28.9691H19.7129C25.4371 28.9691 30.2254 25.8558 31.464 21.6786H10.5827L14.5663 15.5619H30.6485C29.3218 13.3433 26.9222 11.5954 23.9701 10.725H10.5827L14.5663 4.60828H49.4181L45.4345 10.725H35.5304C36.6715 12.1642 37.5373 13.7968 38.0541 15.5619Z"
                              fill="#4E465E"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col col-12 col-md-6 col-lg-3 mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                    <div className="stats-box">
                      <div className="left">
                        <span className="heading">OBTS Collection</span>
                        <span className="amt">
                          ₹{revenuCollected.obtsCollection}
                        </span>
                      </div>
                      <div className="right">
                        <span className="icon">
                          <svg
                            width="75"
                            height="75"
                            viewBox="0 0 75 75"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M59.6836 39.9961V49.2891C59.6851 49.7133 59.6029 50.1336 59.4417 50.5259C59.2804 50.9183 59.0433 51.2749 58.7439 51.5754C58.4444 51.8759 58.0887 52.1144 57.6969 52.277C57.3052 52.4397 56.8851 52.5235 56.4609 52.5235H14.168C13.2882 52.5235 12.444 52.1765 11.8187 51.5577C11.1933 50.939 10.8374 50.0985 10.8281 49.2188V21.0938C10.8281 20.8158 10.8831 20.5405 10.9898 20.2838C11.0965 20.0272 11.253 19.7941 11.4501 19.5981C11.6472 19.402 11.8811 19.2469 12.1384 19.1416C12.3957 19.0363 12.6712 18.9829 12.9492 18.9844H34.1016"
                              stroke="#4E465E"
                              stroke-width="2.8125"
                            />
                            <path
                              d="M60.2227 59.6133H11.1094C10.4749 59.6148 9.84639 59.491 9.25992 59.2489C8.67345 59.0068 8.14058 58.6512 7.69194 58.2026C7.2433 57.754 6.88772 57.2211 6.64564 56.6346C6.40355 56.0482 6.27972 55.4196 6.28126 54.7852V52.5234H64.4531V55.3359C64.4532 56.4623 64.009 57.5432 63.217 58.344C62.4249 59.1448 61.3489 59.6009 60.2227 59.6133Z"
                              stroke="#4E465E"
                              stroke-width="2.8125"
                            />
                            <path
                              d="M37.0781 15.3867H66.2109C66.8761 15.3867 67.5139 15.651 67.9842 16.1213C68.4545 16.5916 68.7188 17.2294 68.7188 17.8946V37.1016C68.7188 37.7667 68.4545 38.4046 67.9842 38.8749C67.5139 39.3452 66.8761 39.6094 66.2109 39.6094H36.0586C35.3935 39.6094 34.7556 39.3452 34.2853 38.8749C33.815 38.4046 33.5508 37.7667 33.5508 37.1016V18.9024C33.5508 18.4397 33.6421 17.9816 33.8195 17.5543C33.9969 17.127 34.2569 16.7389 34.5846 16.4123C34.9123 16.0857 35.3013 15.827 35.7292 15.651C36.157 15.475 36.6155 15.3852 37.0781 15.3867Z"
                              stroke="#4E465E"
                              stroke-width="2.8125"
                            />
                            <path
                              d="M33.5508 20.543H68.7188"
                              stroke="#4E465E"
                              stroke-width="2.8125"
                            />
                            <path
                              d="M33.5508 25.0312H68.7188"
                              stroke="#4E465E"
                              stroke-width="2.8125"
                            />
                            <path
                              d="M61.9922 30.1992C61.3896 30.2034 60.805 30.4052 60.3281 30.7735C59.8472 30.4043 59.2586 30.2026 58.6523 30.1992C57.9282 30.1992 57.2337 30.4869 56.7216 30.999C56.2095 31.511 55.9219 32.2055 55.9219 32.9297C55.9219 33.6539 56.2095 34.3484 56.7216 34.8604C57.2337 35.3725 57.9282 35.6602 58.6523 35.6602C59.2586 35.6568 59.8472 35.4552 60.3281 35.086C60.6717 35.3529 61.0741 35.5338 61.5018 35.6137C61.9294 35.6936 62.37 35.6702 62.7868 35.5453C63.2036 35.4205 63.5845 35.1978 63.8978 34.896C64.2111 34.5941 64.4477 34.2217 64.5879 33.8099C64.7282 33.398 64.768 32.9586 64.704 32.5283C64.6401 32.0979 64.4742 31.6891 64.2202 31.3358C63.9663 30.9826 63.6316 30.6951 63.244 30.4974C62.8564 30.2997 62.4273 30.1975 61.9922 30.1992Z"
                              stroke="#4E465E"
                              stroke-width="2.8125"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col col-12 col-md-6 col-lg-3 mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                    <div className="stats-box">
                      <div className="left">
                        <span className="heading">
                          Goods Transport Collection
                        </span>
                        <span className="amt">
                          ₹{revenuCollected.goodsCollection}
                        </span>
                      </div>
                      <div className="right">
                        <span className="icon">
                          <svg
                            id="Ecommerce_Outline"
                            enable-background="new 0 0 64 64"
                            viewBox="0 0 64 64"
                            height="75"
                            width="75"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#4E465E"
                          >
                            <g>
                              <g>
                                <path d="m16.084 43.66c-1.64 0-2.974 1.333-2.974 2.973s1.334 2.973 2.974 2.973c1.639 0 2.973-1.334 2.973-2.973s-1.334-2.973-2.973-2.973zm0 3.945c-.537 0-.974-.437-.974-.973s.437-.973.974-.973c.536 0 .973.437.973.973 0 .537-.437.973-.973.973z" />
                                <path d="m51.415 43.66c-1.639 0-2.973 1.333-2.973 2.973s1.334 2.973 2.973 2.973 2.973-1.334 2.973-2.973-1.334-2.973-2.973-2.973zm0 3.945c-.536 0-.973-.437-.973-.973s.437-.973.973-.973.973.437.973.973c0 .537-.437.973-.973.973z" />
                                <path d="m60.482 32.669-4.908-10.862c-.872-1.931-2.993-3.179-5.402-3.179h-10.173c-.553 0-1 .448-1 1v13.51h-1.46v-8.095c0-.552-.447-1-1-1h-1.139v-8.194c0-.552-.447-1-1-1h-10.17v-2.799c0-.552-.447-1-1-1h-12.99c-.553 0-1 .448-1 1v11.995h-2.802c-.553 0-1 .448-1 1v8.095h-1.01c-.553 0-1 .448-1 1v12.505c0 .552.447 1 1 1h5.437c.481 3.002 3.083 5.306 6.219 5.306s5.736-2.304 6.218-5.306c0 0 17.696.001 17.697.001h5.198c.482 3.002 3.082 5.305 6.218 5.305s5.736-2.303 6.218-5.305h1.939c.553 0 1-.448 1-1v-13.565c-.001-.142-.031-.282-.09-.412zm-5.875-8.146 3.146 6.961h-8.59c-.617 0-1.119-.449-1.119-1v-4.961c0-.551.502-1 1.119-1zm-33.034 19.032h17.426v2.09h-16.698c-.12-.749-.368-1.454-.728-2.09zm13.966-10.416h-15.11v-7.095h4.415v3.959c0 .552.447 1 1 1h3.963c.553 0 1-.448 1-1v-3.959h4.732zm-23.664-7.095h2.117v2.118h-2.117zm14.969 0h1.963v2.959h-1.963zm3.136-9.193v1.963h-1.964v-1.963zm-3.963 0v2.963c0 .552.447 1 1 1h3.964c.553 0 1-.448 1-1v-2.963h1.42v7.189h-9.17v-7.189zm-8.347-3.801v1.963h-1.964v-1.963zm-6.43 0h2.466v2.963c0 .552.447 1 1 1h3.964c.553 0 1-.448 1-1v-2.963h2.561v2.801 8.189h-10.991zm-3.802 12.994h2.437v3.118c0 .552.447 1 1 1h4.117c.553 0 1-.448 1-1v-3.118h2.437v7.095h-10.991zm31.561 9.095v6.416h-19.21c-1.041-.76-2.319-1.214-3.705-1.214s-2.663.454-3.705 1.214h-6.95v-6.416zm-33.57 8.416h5.165c-.36.636-.608 1.341-.728 2.09h-4.437zm10.655 7.395c-2.374 0-4.306-1.931-4.306-4.305s1.932-4.305 4.306-4.305 4.305 1.931 4.305 4.305-1.931 4.305-4.305 4.305zm35.331 0c-2.374 0-4.305-1.931-4.305-4.305s1.931-4.305 4.305-4.305 4.305 1.931 4.305 4.305-1.931 4.305-4.305 4.305zm6.218-5.304c-.481-3.002-3.082-5.305-6.218-5.305s-5.736 2.303-6.218 5.305h-4.198v-25.017h9.173c1.55 0 2.941.759 3.519 1.894h-4.529c-1.72 0-3.119 1.346-3.119 3v4.961c0 1.654 1.399 3 3.119 3h9.409v1.216h-4.055c-.553 0-1 .448-1 1v3.429c0 .552.447 1 1 1h4.055v5.517zm.938-7.517h-3.055v-1.429h3.055z" />
                                <path d="m46.89 35.45h-2.746c-.553 0-1 .448-1 1s.447 1 1 1h2.746c.553 0 1-.448 1-1s-.448-1-1-1z" />
                              </g>
                            </g>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col col-12 col-md-6 col-lg-3 mb-3 mb-sm-0 mb-md-0 mb-lg-0">
                    <div className="stats-box">
                      <div className="left">
                        <span className="heading">
                          Toll Collection (Melli + Rangpo)
                        </span>
                        <span className="amt">
                          ₹{revenuCollected.totalTollCollection}
                        </span>
                      </div>
                      <div className="right" style={{ paddingTop: "10px" }}>
                        <span className="icon">
                          <svg
                            width="60"
                            height="60"
                            viewBox="0 0 60 60"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1886_1455)">
                              <path
                                d="M39.1383 1.4976L49.18 59.055C49.2939 59.7079 49.9155 60.1448 50.5683 60.0309C51.2212 59.917 51.6581 59.2954 51.5442 58.6425L41.5026 1.0851C41.3887 0.432246 40.7671 -0.0046875 40.1142 0.109219C39.4614 0.223125 39.0244 0.844746 39.1383 1.4976ZM18.4601 1.08516L8.41845 58.6426C8.30454 59.2954 8.74147 59.917 9.39432 60.0309C10.0472 60.1448 10.6688 59.7079 10.7827 59.0551L20.8243 1.49766C20.9382 0.844805 20.5013 0.223184 19.8484 0.109277C19.1956 -0.00462891 18.574 0.432305 18.4601 1.08516ZM28.6257 1.2V6C28.6257 6.66275 29.163 7.2 29.8257 7.2C30.4885 7.2 31.0257 6.66275 31.0257 6V1.2C31.0257 0.537246 30.4885 0 29.8257 0C29.163 0 28.6257 0.537246 28.6257 1.2ZM28.6257 12.8067V20.6067C28.6257 21.2694 29.163 21.8067 29.8257 21.8067C30.4885 21.8067 31.0257 21.2694 31.0257 20.6067V12.8067C31.0257 12.1439 30.4885 11.6067 29.8257 11.6067C29.163 11.6067 28.6257 12.1439 28.6257 12.8067ZM28.6257 27.4133V38.2133C28.6257 38.876 29.163 39.4133 29.8257 39.4133C30.4885 39.4133 31.0257 38.876 31.0257 38.2133V27.4133C31.0257 26.7505 30.4885 26.2133 29.8257 26.2133C29.163 26.2133 28.6257 26.7505 28.6257 27.4133ZM28.6257 45.02V58.82C28.6257 59.4827 29.163 60.02 29.8257 60.02C30.4885 60.02 31.0257 59.4827 31.0257 58.82V45.02C31.0257 44.3572 30.4885 43.82 29.8257 43.82C29.163 43.82 28.6257 44.3572 28.6257 45.02Z"
                                fill="#4E465E"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1886_1455">
                                <rect width="60" height="60" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3">
            <OBTSCollection />
          </div>
        </div>

        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3">
            <InvoiceGeneratedGraph depo={"0"} />
          </div>
        </div>

        <div className="col col-12 col-md-12 col-lg-6">
          <div
            className="graph-outline mb-3"
            // style={{ height: "320px", position: "relative" }}
          >
            <VehicleStatusGraph />
          </div>
        </div>
        <div className="col col-12 col-md-12 col-lg-6">
          <div
            className="graph-outline mb-3 flex-row"
            style={{ justifyContent: "flex-start" }}
          >
            <VehicleStatusList />
          </div>
        </div>

        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3">
            <TollCollection />
          </div>
        </div>
        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3">
            <KmAndFuelReport />
          </div>
        </div>

        {/* <div className="col col-12 col-md-12 col-lg-12">
          <div className="graph-outline mb-3" style={{ height: "600px" }}>
            <MapReport />
          </div>
        </div> */}

        {/* Removed */}
        {/* <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3">
            <TodaysFuelStatusGraph />
          </div>
        </div>
        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3"><GoodsRequested /></div>
        </div>
        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3">
            <ChallanGeneratedGraph />      
          </div>
        </div>
        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3">
            <ChallaRequestReceived />
          </div>
        </div>
        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <FuelConsumptionCentral />
          </div>
        </div>
        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <DutyReports />
          </div>
        </div> */}
      </div>
    </>
  );
}

export default CentralDashboard;
